import { PreferenceContribution, PreferenceSchemaService } from '@theia/core/lib/common/preferences/preference-schema';
import { injectable } from '@theia/core/shared/inversify';
import { SUPPORTED_PRETTIER_LANGUAGE_IDS } from './prettier-formatting-contribution';

@injectable()
export class PrettierPreferenceContribution implements PreferenceContribution {
    async initSchema(service: PreferenceSchemaService): Promise<void> {
        service.updateSchemaProperty('editor.defaultFormatter', { hidden: true });

        for (const languageId of SUPPORTED_PRETTIER_LANGUAGE_IDS) {
            service.registerOverrideIdentifier(languageId);
            service.registerOverride('editor.formatOnSave', languageId, true);
        }
    }
}
